/**
 * Url search param key denoting the selected 'application' filter
 * @type {string}
 */
export const APPLICATION_PARAM = 'application';

/**
 * Url hash for setting an anchor to this app
 * @type {string}
 */
export const APP_ANCHOR = 'interactiveSensorPortal';

/**
 * Minimum time period in ms during which atleast 75% of the app container is visible on user's screen,
 * indicating that the user has viewed the app
 * @type {number}
 */
export const APP_VIEWED_MINIMUM_TIME_PERIOD = 2000;

/**
 * Object containing broken image error messages for each locale.
 * @type {object}
 */
export const BROKEN_IMAGE_ERROR = {
	en: `Oops! Sorry, we couldn't load the image.`,
	ja: `おっとっと！申し訳ありませんが、画像を読み込めませんでした。`,
	zh: `哎呀！抱歉，我们无法加载图像。`,
};

/**
 * Default period of user inactivity in ms after which a telemetry api call should be made
 * @type {number}
 */
export const DEFAULT_INACTIVITY_PERIOD = 2500;

/**
 * Object containing generic error messages for each locale. This is used for any runtime error in jsx.
 * @type {object}
 */
export const GENERIC_ERROR = {
	en: `We're sorry but an error has occurred in the 'Sensor Interface Solutions'. Please try again after a few hours.`,
	ja: `申し訳ございませんが、「センサー インターフェイス ソリューション」でエラーが発生しました。数時間後にもう一度試してください。`,
	zh: `很抱歉，“传感器接口解决方案”中出现错误。请几个小时后重试。`,
};

/**
 * Url search param key denoting the id of the unique solution corresponding to the combination of
 * 'application', 'sensorType' and 'optimization' filters
 * @type {string}
 */
export const SOLUTION_ID_PARAM = 'solutionId';

/**
 * Url search param key denoting the selected 'sensorType' filter
 * @type {string}
 */
export const SENSOR_TYPE_PARAM = 'sensorType';

/**
 * Url search param key denoting the selected 'optimization' filter
 * @type {string}
 */
export const OPTIMIZATION_PARAM = 'optimization';

/**
 * Url search param key denoting the selected 'tab' of a solution
 * @type {string}
 */
export const SELECTED_TAB_PARAM = 'selectedTab';
